var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"sidebar no-print"},[_c('Sidebar')],1),_c('ChildrenMenu',{staticClass:"no-print"}),_c('div',{staticClass:"body"},[_c('BodyMain')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }